import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const LeftSideBar = () => {
  const [activePath, setActivePath] = useState('');
  const [openSubMenu, setOpenSubMenu] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  const handleClick = (path) => {
    if (activePath === path) {
      setActivePath('');
    } else {
      setActivePath(path);
      navigate(path);
    }
  };

  const toggleSubMenu = (key, path) => {
    if (openSubMenu === key) {
      setOpenSubMenu('');
    } else {
      setOpenSubMenu(key);
      setActivePath(path);
      navigate(path);
    }
  };

useEffect(() => {
  if (location.pathname.startsWith('/direct-tax-services') ||
      ['/income-tax', '/corporate-tax', '/international-tax-services', '/transfer-pricing', '/dtaa-advisory', '/nri-taxatios'].includes(location.pathname)) {
    setOpenSubMenu('direct-tax-services');
  } else if (location.pathname.startsWith('/indirect-tax-service') || location.pathname === '/gst-compliance') {
    setOpenSubMenu('indirect-tax-service');
  } else {
    setOpenSubMenu('');
  }
}, [location.pathname]);

useEffect(() => {
  if (
    ['/direct-tax-services', '/income-tax', '/corporate-tax', '/international-tax-services', '/transfer-pricing', '/dtaa-advisory', '/nri-taxatios'].includes(location.pathname)
  ) {
    setOpenSubMenu('direct-tax-services');
  } else if (
    ['/indirect-tax-service', '/gst-compliance', '/gst-due-diligence-services', '/gst-opinion-services', '/gst-classification-services', '/gst-litigation-services', '/gst-search-inquiry-support-services', '/e-way-bill-consultancy-services', '/gst-refund-services', '/gst-return-preparation-services' ].includes(location.pathname)
  ) {
    setOpenSubMenu('indirect-tax-service');
  } else {
    setOpenSubMenu('');
  }
}, [location.pathname]);

  const isParentActive = (parentPath, subMenuPaths) =>
    activePath === parentPath || subMenuPaths.includes(activePath);
  return (
    <div className="container-no">
      <div className="services_list_wrap">
        <h4>OUR SERVICES</h4>
        <ul className="p-0 m-0">
          {/* Incorporation Menu */}
          <li>
            <a
              className={isParentActive('/incorporation', [
                '/sole-proprietorship',
                '/partnership-firm',
                '/limited-liability',
                '/one-person-company',
                '/private-limited-company',
                '/public-limited-company',
              ])
                ? 'active'
                : ''}
              onClick={() => handleClick('/incorporation')} >
              Incorporation
            </a>
            <ul className="dropdaun_menu">
              <li>
                <a className={activePath === '/sole-proprietorship' ? 'active' : ''} onClick={() => handleClick('/sole-proprietorship')}> Sole Proprietorship</a>
              </li>
              <li>
                <a  className={activePath === '/partnership-firm' ? 'active' : ''} onClick={() => handleClick('/partnership-firm')}>Partnership Firm</a>
              </li>
              <li>
                <a  className={activePath === '/limited-liability' ? 'active' : ''} onClick={() => handleClick('/limited-liability')}>Limited Liability Partnership (LLP)</a>
              </li>
              <li>
                <a className={activePath === '/one-person-company' ? 'active' : ''} onClick={() => handleClick('/one-person-company')}>One Person Company</a>
              </li>
              <li>
                <a className={activePath === '/private-limited-company' ? 'active' : ''} onClick={() => handleClick('/private-limited-company')}>Private Limited Company</a>
              </li>
              <li>
                <a className={activePath === '/public-limited-company' ? 'active' : ''} onClick={() => handleClick('/public-limited-company')}>Public Limited Company </a>
              </li>
            </ul>
          </li>
          {/* Accounting Menu */}
          <li className='remove_icon'>
            <a className= {isParentActive('/accounting', [
              ]) ? 'active' : ''} onClick={() => handleClick('/accounting')}> Accounting
            </a>
          </li>
          {/* Taxation Menu */}
          <li>
              <a
                className={isParentActive('/taxation', [
                  '/direct-tax-services', '/income-tax', '/corporate-tax',
                  '/international-tax-services', '/transfer-pricing',
                  '/dtaa-advisory', '/nri-taxatios',
                  '/indirect-tax-service', '/gst-compliance',
                  '/indirect-tax-service', '/gst-due-diligence-services',
                  '/indirect-tax-service', '/gst-opinion-services',
                  '/indirect-tax-service', '/gst-classification-services',
                  '/indirect-tax-service', '/gst-litigation-services',
                  '/indirect-tax-service', '/gst-search-inquiry-support-services',
                  '/indirect-tax-service', '/e-way-bill-consultancy-services',
                  '/indirect-tax-service', '/gst-refund-services',
                  '/indirect-tax-service', '/gst-return-preparation-services',
                ]) ? 'active' : ''}
                onClick={() => handleClick('/taxation')}
              >
                Taxation
              </a>
              

                  <ul className="dropdaun_menu p-2 pt-1 pb-1">
                    {/* Direct Tax Services Toggle */}
                    <li>
                     <a
                        className={openSubMenu === 'direct-tax-services' ? 'active' : ''}
                        onClick={() => toggleSubMenu('direct-tax-services', '/direct-tax-services')}
                      >
                        Direct Tax Services <i class="fas fa-chevron-right"></i>
                      </a>
                      {openSubMenu === 'direct-tax-services' && (
                        <ul className="p-2 pt-0 pb-0">
                          <li>
                            <a className={activePath === '/income-tax' ? 'active' : ''} onClick={() => handleClick('/income-tax')}>Income Tax</a>
                          </li>
                          <li>
                            <a className={activePath === '/corporate-tax' ? 'active' : ''} onClick={() => handleClick('/corporate-tax')}>Corporate Tax</a>
                          </li>
                          <li>
                            <a className={activePath === '/international-tax-services' ? 'active' : ''} onClick={() => handleClick('/international-tax-services')}>International Tax Services</a>
                          </li>
                          <li>
                            <a className={activePath === '/transfer-pricing' ? 'active' : ''} onClick={() => handleClick('/transfer-pricing')}>Transfer Pricing</a>
                          </li>
                          <li>
                            <a className={activePath === '/dtaa-advisory' ? 'active' : ''} onClick={() => handleClick('/dtaa-advisory')}>DTAA Advisory</a>
                          </li>
                          <li>
                            <a className={activePath === '/nri-taxatios' ? 'active' : ''} onClick={() => handleClick('/nri-taxatios')}>NRI Taxatios</a>
                          </li>
                        </ul>
                      )}
                    </li>
                    {/* Indirect Tax Services Toggle */}
                    <li>
                      <a
                        className={openSubMenu === 'indirect-tax-service' ? 'active' : ''}
                        onClick={() => toggleSubMenu('indirect-tax-service', '/indirect-tax-service')}
                      >
                        Indirect Tax Service <i className="fas fa-chevron-right"></i>
                      </a>
                      {openSubMenu === 'indirect-tax-service' && (
                        <ul className="p-2 pt-0 pb-0">
                          <li>
                            <a className={activePath === '/gst-compliance' ? 'active' : ''} onClick={() => handleClick('/gst-compliance')}>GST Compliance</a>
                          </li>
                          <li>
                            <a className={activePath === '/gst-due-diligence-services' ? 'active' : ''} onClick={() => handleClick('/gst-due-diligence-services')}>GST Due Diligence Services</a>
                          </li>
                          <li>
                            <a className={activePath === '/gst-opinion-services' ? 'active' : ''} onClick={() => handleClick('/gst-opinion-services')}>GST Opinion Services</a>
                          </li>
                          <li>
                            <a className={activePath === '/gst-classification-services' ? 'active' : ''} onClick={() => handleClick('/gst-classification-services')}>GST Classification Services</a>
                          </li>
                          <li>
                            <a className={activePath === '/gst-litigation-services' ? 'active' : ''} onClick={() => handleClick('/gst-litigation-services')}>GST Litigation Services</a>
                          </li>
                          <li>
                            <a className={activePath === '/gst-search-inquiry-support-services' ? 'active' : ''} onClick={() => handleClick('/gst-search-inquiry-support-services')}>GST Search Inquiry Support Services</a>
                          </li>
                          <li>
                            <a className={activePath === '/e-way-bill-consultancy-services' ? 'active' : ''} onClick={() => handleClick('/e-way-bill-consultancy-services')}>E-way Bill Consultancy Services</a>
                          </li>
                          <li>
                            <a className={activePath === '/gst-refund-services' ? 'active' : ''} onClick={() => handleClick('/gst-refund-services')}>GST Refund Services</a>
                          </li>
                          <li>
                            <a className={activePath === '/gst-return-preparation-services' ? 'active' : ''} onClick={() => handleClick('/gst-return-preparation-services')}>GST Return Preparation Services </a>
                          </li>
                        </ul>
                      )}
                    </li>
                  </ul>
          </li>
          <li className='remove_icon'>
            <a className= {isParentActive('/specialized_tax-services', [
              ]) ? 'active' : ''} onClick={() => handleClick('/specialized_tax-services')}>Specialized Tax Services
            </a>
          </li>

          {/* Audit memu */}
          <li>
            <a
              className={isParentActive('/audit-and-assurance-services', [
                '/statutory-audit-services',
                '/internal-audit-services',
                '/tax-audit-services',
                '/forensic-audit-services',
                '/gst-audit-services',
                '/concurrent-audit-services',
                '/compliance-audit-services',
                '/information-system-audit-services',
                '/management-audit&risk-assessment-services',
                '/departmental&process-audit-services'
              ])
                ? 'active'
                : ''}
              onClick={() => handleClick('/audit-and-assurance-services')} >
              Audit And Assurance Services
            </a>
            <ul className="dropdaun_menu">
              <li>
                <a className={activePath === '/statutory-audit-services' ? 'active' : ''} onClick={() => handleClick('/statutory-audit-services')}>Statutory Audit Services</a>
              </li>
              <li>
                <a className={activePath === '/internal-audit-services' ? 'active' : ''} onClick={() => handleClick('/internal-audit-services')}>Internal Audit Services</a>
              </li>
              <li>
                <a className={activePath === '/tax-audit-services' ? 'active' : ''} onClick={() => handleClick('/tax-audit-services')}>Tax Audit Services</a>
              </li>
              <li>
                <a className={activePath === '/forensic-audit-services' ? 'active' : ''} onClick={() => handleClick('/forensic-audit-services')}>Forensic Audit Services</a>
              </li>
              <li>
                <a className={activePath === '/gst-audit-services' ? 'active' : ''} onClick={() => handleClick('/gst-audit-services')}>GST Audit Services</a>
              </li>
              <li>
                <a className={activePath === '/concurrent-audit-services' ? 'active' : ''} onClick={() => handleClick('/concurrent-audit-services')}>Concurrent Audit Services</a>
              </li>
              <li>
                <a className={activePath === '/compliance-audit-services' ? 'active' : ''} onClick={() => handleClick('/compliance-audit-services')}>Compliance Audit Services</a>
              </li>
              <li>
                <a className={activePath === '/information-system-audit-services' ? 'active' : ''} onClick={() => handleClick('/information-system-audit-services')}>Information System Audit Services</a>
              </li>
              <li>
                <a className={activePath === '/management-audit&risk-assessment-services' ? 'active' : ''} onClick={() => handleClick('/management-audit&risk-assessment-services')}>Management Audit & Risk Assessment</a>
              </li>
              <li>
                <a className={activePath === '/departmental&process-audit-services' ? 'active' : ''} onClick={() => handleClick('/departmental&process-audit-services')}>Departmental & Process Audit Services</a>
              </li>
            </ul>
          </li>

          {/* Consultancy Services */}
          <li>
            <a
              className={isParentActive('/consultancy-services', [
                '/business-advisory&corporate-strategy',
                '/risk&compliance-consultancy',
                '/startup&sme-consultancy',
                '/finance-consultancy',
                '/corporate-finance&transaction-advisory',
                '/it&digital-transformation-advisory',
                '/wealth-trust&succession-planning'
              ])
                ? 'active'
                : ''}
              onClick={() => handleClick('/consultancy-services')} >
              Consultancy Services
            </a>
            <ul className="dropdaun_menu">
              <li>
                <a className={activePath === '/business-advisory&corporate-strategy' ? 'active' : ''} onClick={() => handleClick('/business-advisory&corporate-strategy')}>Business Advisory & Corporate Strategy</a>
              </li>
              <li>
                <a className={activePath === '/risk&compliance-consultancy' ? 'active' : ''} onClick={() => handleClick('/risk&compliance-consultancy')}>Risk & Compliance Consultancy</a>
              </li>
              <li>
                <a className={activePath === '/startup&sme-consultancy' ? 'active' : ''} onClick={() => handleClick('/startup&sme-consultancy')}>Startup & SME Consultancy</a>
              </li>
              <li>
                <a className={activePath === '/finance-consultancy' ? 'active' : ''} onClick={() => handleClick('/finance-consultancy')}>Finance Consultancy</a>
              </li>
              <li>
                <a className={activePath === '/corporate-finance&transaction-advisory' ? 'active' : ''} onClick={() => handleClick('/corporate-finance&transaction-advisory')}>Corporate Finance & Transaction</a>
              </li>
              <li>
                <a className={activePath === '/it&digital-transformation-advisory' ? 'active' : ''} onClick={() => handleClick('/it&digital-transformation-advisory')}>IT & Digital Transformation Advisory</a>
              </li>
              <li>
                <a className={activePath === '/wealth-trust&succession-planning' ? 'active' : ''} onClick={() => handleClick('/wealth-trust&succession-planning')}>Wealth Trust & Succession Planning</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};


export default LeftSideBar;
